import { render, staticRenderFns } from "./Tour.vue?vue&type=template&id=6266a4e7&scoped=true&"
import script from "./Tour.vue?vue&type=script&lang=js&"
export * from "./Tour.vue?vue&type=script&lang=js&"
import style0 from "./Tour.vue?vue&type=style&index=0&id=6266a4e7&lang=scss&scoped=true&"
import style1 from "./Tour.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6266a4e7",
  null
  
)

export default component.exports